import { useClientKpis } from "@pages/mmm/hooks/use-client-kpis";

export function useModelMetadataKpis() {
  const { kpis } = useClientKpis();

  return { kpis };
}
